import React from "react";
import ProductCard from "./ProductCard";

const SingleProductCard = ({ item }) => {
  return (
    <ProductCard
      item={item}
      children={
        <>
          <p
            style={{ margin: "10px 0px" }}
            dangerouslySetInnerHTML={{
              __html: item?.description?.substring(0, 100) + "...",
            }}
          ></p>
        </>
      }
    />
  );
};

export default SingleProductCard;
